// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__14Kk3","title":"InfoRow_title__DVKPx"};